window.$ = window.jQuery;

$(document).ready(function() {
  // Gestione apertura popup tramite hash URL
  $(document).on('click', 'a[href^="#popup-"]', function(e) {
    e.preventDefault();
    const popupId = $(this).attr('href').substring(1); // Rimuove il # dall'inizio
    openPopup(popupId);
  });

  // Gestione chiusura popup
  $('.o-popup__close, .backplate').on('click', function() {
    closePopup();
  });
});

// Funzione per aprire il popup
function openPopup(popupId) {
  const $popup = $(`.o-popup[data-popup-id="${popupId}"]`);
  
  if ($popup.length) {
    $('.backplate').addClass('backplate--open');
    $popup.addClass('o-popup--open');
    $('html').addClass('overflow-hidden');
  }
}

// Funzione per chiudere il popup
function closePopup() {
  $('.backplate').removeClass('backplate--open');
  $('.o-popup').removeClass('o-popup--open');
  $('html').removeClass('overflow-hidden');
}

// Controlla se c'è un hash nell'URL all'avvio
$(window).on('load', function() {
  const hash = window.location.hash;
  if (hash && hash.startsWith('#popup-')) {
    openPopup(hash.substring(1));
  }
});